import * as React from "react";
import { ListChecks, ShieldCheck, Package } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const pillars = [{
  title: "Projection Mapping",
  description: "Transforming stage environments into reactive canvases that pulse and breathe in sync with the musical arrangement.",
  icon: ListChecks
}, {
  title: "Visual Synthesis",
  description: "Crafting high-contrast, grain-heavy imagery that mirrors the raw authenticity of alternative music production.",
  icon: ShieldCheck
}, {
  title: "Immersive Design",
  description: "Experimental light installations designed to bridge the gap between sonic frequency and visual perception.",
  icon: Package
}];
export default function QualityFirst() {
  return;
}